// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2JZvm","select":"styles_select__3v8j8"};